module.exports = __webpack_public_path__ + "static/2_1_search-2_EL-af9999833e07b0f3d449db346dfc6a06.svg";